import styled from "styled-components";

interface TypographyBoxProps {
	color: string;
}

export const TypographyBox = styled.div`
	width: 1200px;
	margin: 0 auto;
	padding: 12px;
	box-sizing: border-box;
	color: ${props => props?.theme?.mainFontColor};
	background-color: ${(props: TypographyBoxProps) => props.color};
	& > div {
		overflow: hidden;
		padding: 0;
		margin: 0;
	}
`;
